import { styled, Stack, Link, IconButton } from "@mui/material";
import { BodyTextM, BodyTextS } from "./Typography";

export const Wrapper = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(4),
}));

export const DownloadButton = styled(IconButton)(({ theme }) => ({
  alignSelf: "flex-start",
  padding: theme.spacing(1),
}));

export const InfoStack = styled(Stack)(() => ({
  flexGrow: 1,
  flexBasis: "50%",
  minWidth: 0,
}));

export const NameRow = styled(BodyTextM)(({ theme }) => ({
  overflow: "hidden",
  color: theme.palette.primary.main,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "flex",
  alignItems: "center",
}));

export const FileLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export const Meta = styled(BodyTextS)(() => ({
}));

export const DownloadLink = styled(Link)(() => ({
  display: "inline-flex",
  textDecoration: "none",
  color: "inherit",
}));